import React, { useState } from "react";
import Modal from "../../../parts/modal-new";
import { upperFirst, round } from "lodash";
const LIFTING_STANDARDS = {
  squat: 0.23,
  bench: 0.1,
  deadlift: 0.14,
};
const VelocityModal = ({ hideVelocitySettings, thresholds, setThresholds }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        data-button-type="tertiary"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
        disabled={hideVelocitySettings}
      >
        Modify MVT
      </button>
      <Modal
        title={"Velocity Based Training"}
        className={`velocity-modal ${isOpen ? "" : "!hidden"}`}
        onClose={() => setIsOpen(false)}
      >
        <div className="body">
          <h4 className="mt-2 mb-6">Minimum Velocity Threshold</h4>
          <p className="p5">
            The minimum velocity threshold (MVT). This is the velocity that
            corresponds with a lifter's 1RM. It's literally the slowest speed at
            which a lifter can successfully complete a rep for the given
            exercise. Think of this as the end of the line for your
            load-velocity profile. In practical terms this represents your
            ability to produce enough acceleration on the weight to overcome
            gravity, any slower and the rep would be a fail.
          </p>
          <p className="p5 mt-2 mb-12">
            Customize the minimum velocity threshold (MVT) used to estimate a
            lifter 1 rep max (v1RM)
          </p>

          <header>
            <span></span>
            <span>Industry Standard (MVT)</span>
            <span>Modification</span>
            <span>Modified MVT</span>
          </header>

          {["squat", "bench", "deadlift"].map((lift) => (
            <div className="velocity-table-row" key={`${lift}-velocity`}>
              <div>
                <span>{upperFirst(lift)}</span>
              </div>
              <span>{LIFTING_STANDARDS[lift]}</span>
              <div className="velocity-threshold-control">
                <button
                  data-button-type="secondary"
                  data-icon-only
                  onClick={(e) => {
                    e.preventDefault();
                    setThresholds({
                      ...thresholds,
                      [lift]: thresholds[lift] - 0.01,
                    });
                  }}
                >
                  <img
                    src="/img/new-icons/less-gradient.svg"
                    alt="minus-velocity"
                  />
                </button>
                <input
                  type="text"
                  name={`${lift}Threshold`}
                  className="velocity-threshold-control-input"
                  readOnly
                  value={round(thresholds[lift], 3).toFixed(2)}
                />
                <button
                  data-button-type="secondary"
                  data-icon-only
                  onClick={(e) => {
                    e.preventDefault();
                    setThresholds({
                      ...thresholds,
                      [lift]: thresholds[lift] + 0.01,
                    });
                  }}
                >
                  <img
                    src="/img/new-icons/add-gradient-icon.svg"
                    alt="plus-velocity"
                  />
                </button>
              </div>
              <span>
                {(LIFTING_STANDARDS[lift] + thresholds[lift]).toFixed(2)}
              </span>
            </div>
          ))}
        </div>
        <footer>
          <button
            data-button-type="secondary"
            data-action="cancel"
            onClick={(e) => {
              e.preventDefault();
              setIsOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            data-button-type="primary"
            onClick={(e) => {
              e.preventDefault();
              setIsOpen(false);
            }}
          >
            Save
          </button>
        </footer>
      </Modal>
    </>
  );
};

export default VelocityModal;
